/* eslint-disable @typescript-eslint/no-explicit-any */
import * as types from "../actionTypes/loginActionTypes";

export const LoginGQLAgentAction = {
  STARTED: (
    payload: any
    // logincallback: (response: any) => void,
    // usercallback: (response: any) => void
  ) => ({
    type: types.SET_GQL_AUTH_LOGIN.STARTED,
    payload,
    // logincallback,
    // usercallback,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_GQL_AUTH_LOGIN.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_GQL_AUTH_LOGIN.REJECTED,
    payload: error,
  }),
  RESET: () => ({
    type: types.SET_GQL_AUTH_LOGIN.RESET,
  }),
};

export const LoginGQLRefreshToken = {
  STARTED: (
    payload: any
    // logincallback: (response: any) => void,
    // usercallback: (response: any) => void
  ) => ({
    type: types.SET_GQL_REFRESH_TOKEN.STARTED,
    payload,
    // logincallback,
    // usercallback,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_GQL_REFRESH_TOKEN.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_GQL_REFRESH_TOKEN.REJECTED,
    payload: error,
  }),
};

export const setLogOut = () => {
  return {
    type: types.SET_AUTH_LOGOUT,
  };
};
export const GQLAgentContactDetailsAction = {
  STARTED: (payload: any) => ({
    type: types.SET_GQL_AGENT_CONTACT_DETAILS.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_GQL_AGENT_CONTACT_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_GQL_AGENT_CONTACT_DETAILS.REJECTED,
    payload: error,
  }),
};
export const GqlGstStateCodeAction = {
  STARTED: (payload: any) => ({
    type: types.SET_GQL_GST_STATE_CODE.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_GQL_GST_STATE_CODE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_GQL_GST_STATE_CODE.REJECTED,
    payload: error,
  }),
};

export const GqlCountriesCodeAction = {
  STARTED: () => ({
    type: types.SET_GQL_COUNTRIES_CODE.STARTED,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_GQL_COUNTRIES_CODE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_GQL_COUNTRIES_CODE.REJECTED,
    payload: error,
  }),
};

export const GqlCitiesCodeAction = {
  STARTED: (payload: any) => ({
    type: types.SET_GQL_CITIES_CODE.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_GQL_CITIES_CODE.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_GQL_CITIES_CODE.REJECTED,
    payload: error,
  }),
};

export const GqlCurrencyListAction = {
  STARTED: () => ({
    type: types.SET_GQL_CURRENCY_LIST.STARTED,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_GQL_CURRENCY_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_GQL_CURRENCY_LIST.REJECTED,
    payload: error,
  }),
};

export const setForgotPasswordAction = {
  STARTED: (payload: any, navigate: any) => ({
    type: types.SET_AUTH_FORGOTPASSWORD.STARTED,
    payload,
    navigate,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_AUTH_FORGOTPASSWORD.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_AUTH_FORGOTPASSWORD.REJECTED,
    payload: error,
  }),
};

export const setResetPasswordAction = {
  STARTED: (payload: any) => ({
    type: types.SET_AUTH_RESETPASSWORD.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_AUTH_RESETPASSWORD.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_AUTH_RESETPASSWORD.REJECTED,
    payload: error,
  }),
};

export const setResetPasswordLSAction = {
  STARTED: (payload: any) => ({
    type: types.SET_AUTH_RESETPASSWORDLS.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_AUTH_RESETPASSWORDLS.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_AUTH_RESETPASSWORDLS.REJECTED,
    payload: error,
  }),
};

export const setResendOTPAction = {
  STARTED: (payload: any) => ({
    type: types.SET_AUTH_RESENDOTP.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_AUTH_RESENDOTP.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_AUTH_RESENDOTP.REJECTED,
    payload: error,
  }),
};

export const setVerifyOTPAction = {
  STARTED: (payload: any) => ({
    type: types.SET_AUTH_VERIFYOTP.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_AUTH_VERIFYOTP.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_AUTH_VERIFYOTP.REJECTED,
    payload: error,
  }),
};

export const setChangePasswordAction = {
  STARTED: (payload: any) => ({
    type: types.SET_AUTH_CHANGEPASSWORD.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.SET_AUTH_CHANGEPASSWORD.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: string) => ({
    type: types.SET_AUTH_CHANGEPASSWORD.REJECTED,
    payload: error,
  }),
};

export const generateAccessTokenAction = {
  STARTED: (payload: any) => ({
    type: types.GENERATE_ACCESS_TOKEN_DETAILS.STARTED,
    payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GENERATE_ACCESS_TOKEN_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({
    type: types.GENERATE_ACCESS_TOKEN_DETAILS.REJECTED,
  }),
};
